import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, switchMap } from 'rxjs';
import { DualAuthService } from './DualAuthService';
import { Notification } from '../models/Notification';

@Injectable()
export default class NotificationService {
  baseUrl = `${environment.backend.baseUrl}${environment.backend.apiUrl}/Notification`;
  constructor(private http: HttpClient, private auth: DualAuthService) {}

  notify(message: string): Observable<Notification> {
    return this.auth.currentUser$.pipe(
      switchMap((user) =>
        this.http.post<Notification>(`${this.baseUrl}/notify`, {
          UserId: user?.email,
          Message: message,
        })
      )
    );
  }

  loadNotificationsForCustomer(): Observable<Notification[]> {
    return this.http.get<Notification[]>(`${this.baseUrl}/customer`)
  }

  getNotifications(customerNo: number): Observable<Notification[]> {
    return this.http.get<Notification[]>(`${this.baseUrl}/${customerNo}`);
  }

  markAsRead(id: number): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${id}/mark-read`, {});
  }

  createNotification(notification: Notification): Observable<Notification> {
    return this.http.post<Notification>(`${this.baseUrl}`, notification);
  }
}
